export default __webpack_public_path__ + "static/awards-pc-arg-3d5fc1ceda14e684f8fda8ba760db223.png";